import Basic from './Basic.jsx';
// import Floating from "./Floating.jsx";
import Upload from './Upload.jsx';
import DropDown from './DropDown.jsx';

const ButtonExports = {
  Basic,
  Upload,
  // Floating,
  DropDown,
};
export default ButtonExports;
